//* Libraries imports
import { Headphones, MessageCircle } from "lucide-react";

type PaymentSupportProps = {
  onWhatsAppClick: (phone?: string) => void;
  responsible: any;
};

export function PaymentSupport({
  onWhatsAppClick,
  responsible,
}: PaymentSupportProps) {
  const name = responsible?.name || "Suporte";
  const whatsapp = responsible?.whatsapp || "(17) 99246-0986"; //todo: ajustar depois
  const image =
    responsible?.image ||
    responsible?.photoUrl ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=1777CF&color=fff`;

  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <Headphones size={16} className="text-clarotexto-202" />
        <h2 className="text-clarotexto-202 text-xs font-semibold uppercase tracking-wider">
          Contato de suporte
        </h2>
      </div>

      <p className="text-clarotextos-02 text-xs leading-relaxed">
        Em caso de dúvidas entre em contato com o responsável pelo seu
        atendimento.
      </p>

      {/* Responsável */}
      <div className="flex items-center gap-3 p-1">
        <div className="size-12 rounded-xl border border-clarobordas-01 overflow-hidden shadow-sm flex items-center justify-center bg-claroborg-202">
          <img src={image} alt={name} className="w-full h-full object-cover" />
        </div>
        <div className="flex flex-col gap-0.5">
          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider">
            Responsável
          </span>
          <span className="text-clarotexto-202 text-sm font-semibold">
            {name}
          </span>
        </div>
      </div>

      <div className="h-px w-full bg-clarobordas-01" />

      {/* WhatsApp Section */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <MessageCircle
            size={20}
            className="text-emerald-500 fill-emerald-500/10"
          />
          <div className="flex flex-col gap-0.5">
            <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider">
              WhatsApp
            </span>
            <span className="text-clarotexto-202 text-sm font-bold">
              {whatsapp}
            </span>
          </div>
        </div>

        <button
          onClick={() => onWhatsAppClick(whatsapp)}
          className="w-full h-9 bg-emerald-500 text-white rounded-lg flex items-center justify-center gap-2 font-semibold text-xs hover:bg-emerald-600 transition-colors shadow-sm"
        >
          <MessageCircle size={16} className="fill-white" />
          Conversar no WhatsApp
        </button>
      </div>
    </section>
  );
}
